import { sdk } from "~lib";

export const useReCaptchaSDK = () => {
  // eslint-disable-next-line @typescript-eslint/require-await
  const recaptchaSdkGenerator = async (_: string) => sdk;

  return {
    recaptchaSdkGenerator,
  };
};
